export type WallColorId = "zwart" | "naturel";

export type WallProfileId = "potdeksel" | "blockhut" | "vuren";

export interface WallFinishVariant {
  profileId: WallProfileId;
  colorId: WallColorId;
  value: string;
  label: string;
  imageUrl: string;
}

const IMAGE_BASE = `${process.env.PUBLIC_URL}/images`;

export const WALL_FINISH_VARIANTS: WallFinishVariant[] = [
  {
    profileId: "vuren",
    colorId: "zwart",
    value: "wall_vuren_black",
    label: "Vuren rabat zwart gespoten",
    imageUrl: `${IMAGE_BASE}/Vuren_rabat_zwart.png`,
  },
  {
    profileId: "potdeksel",
    colorId: "naturel",
    value: "wall_potdeksel",
    label: "Douglas rabat naturel",
    imageUrl: `${IMAGE_BASE}/Douglas_Rabat_naturel_def.png`,
  },
  // {
  //   profileId: "potdeksel",
  //   colorId: "zwart",
  //   value: "wall_potdeksel_black",
  //   label: "Douglas rabat Zwart",
  //   imageUrl: `${IMAGE_BASE}/buitenwand-1.png`,
  // },
  {
    profileId: "blockhut",
    colorId: "naturel",
    value: "wall_blockhut",
    label: "Blokhutprofiel naturel",
    imageUrl: `${IMAGE_BASE}/Blokhutprofiel_wand_def.png`,
  },
  // {
  //   profileId: "blockhut",
  //   colorId: "zwart",
  //   value: "wall_blockhut_black",
  //   label: "Blokhutprofiel zwart",
  //   imageUrl: `${IMAGE_BASE}/buitenwand-1.png`,
  // },
];

export const WALL_COLOR_OPTIONS: { id: WallColorId; label: string }[] = [
  { id: "zwart", label: "Zwart" },
  { id: "naturel", label: "Naturel" },
];

export const WALL_PROFILE_OPTIONS: {
  id: WallProfileId;
  label: string;
}[] = [
  { id: "potdeksel", label: "Douglas" },
  { id: "blockhut", label: "Blokhutprofiel" },
  { id: "vuren", label: "Vurenprofiel" },
];

const DEFAULT_COLOR: WallColorId = "zwart";
const DEFAULT_PROFILE: WallProfileId = "potdeksel";

const findVariant = (
  profileId: WallProfileId,
  colorId: WallColorId
): WallFinishVariant => {
  return (
    WALL_FINISH_VARIANTS.find(
      (variant) =>
        variant.profileId === profileId && variant.colorId === colorId
    ) ??
    WALL_FINISH_VARIANTS.find(
      (variant) =>
        variant.profileId === DEFAULT_PROFILE &&
        variant.colorId === DEFAULT_COLOR
    )!
  );
};

export const getColorFromFinish = (value: string): WallColorId => {
  const variant =
    WALL_FINISH_VARIANTS.find((item) => item.value === value) ?? null;

  return variant ? variant.colorId : DEFAULT_COLOR;
};

export const getProfileFromFinish = (value: string): WallProfileId => {
  const variant =
    WALL_FINISH_VARIANTS.find((item) => item.value === value) ?? null;

  return variant ? variant.profileId : DEFAULT_PROFILE;
};

export const getFinishValue = (
  profileId: WallProfileId,
  colorId: WallColorId
): string => {
  return findVariant(profileId, colorId).value;
};

export const getVariantsForColor = (
  colorId: WallColorId
): WallFinishVariant[] => {
  return WALL_FINISH_VARIANTS.filter((variant) => variant.colorId === colorId);
};

export const isBlockhutFinish = (value: string): boolean => {
  return getProfileFromFinish(value) === "blockhut";
};
